import { css } from '@emotion/core';
import isNumber from 'lodash/isNumber';

export const trigger = css`
  display: inline-flex;
`;

type Placement = 'top' | 'bottom' | 'left' | 'right';

const placementStyles = {
  right: css`
    transform: translate(8px, -50%);

    &::after {
      top: 50%;
      right: 100%;
      transform: translateY(-50%);
      border-right-color: #2d3748;
    }
  `,
  left: css`
    transform: translate(-8px, -50%) translateX(-100%);

    &::after {
      top: 50%;
      left: 100%;
      transform: translateY(-50%);
      border-left-color: #2d3748;
    }
  `,
  top: css`
    transform: translate(-50%, -8px) translateY(-100%);

    &::after {
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      border-top-color: #2d3748;
    }
  `,
  bottom: css`
    transform: translate(-50%, 8px);

    &::after {
      bottom: 100%;
      left: 50%;
      transform: translateX(-50%);
      border-bottom-color: #2d3748;
    }
  `,
};

export const tooltip = (width: number | string, placement: Placement = 'right') => css`
  position: fixed;
  width: ${isNumber(width) ? `${width}px` : width};

  background: #2d3748;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.14), 0 4px 8px rgba(0, 0, 0, 0.28);
  color: #fff;
  padding: 8px 10px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 1.4;

  z-index: 999999;
  pointer-events: none;

  ${placementStyles[placement]}

  &::after {
    content: '';
    position: absolute;
    border: 6px solid transparent;
  }
`;
